import Fetch from '../Fetch';

export default {
  queryRadiusInfo: () => {
    return Fetch.get(`/api/v1/radius_config`);
  },
  updateRadiusInfo: (params) => {
    return Fetch.post(`/api/v1/radius_config`, params);
  },
  deleteRadiusInfo: (params) => {
    return Fetch.post(`/api/v1/delete_radius_server`, params);
  },
  queryAccessControlList: () => {
    return Fetch.get(`/api/v1/swsec_acl_list`);
  },
  deleteAccessControlList: (params) => {
    return Fetch.delete(`/api/v1/swsec_acl_list`, { params });
  },
  updateAccessControlList: (params) => {
    return Fetch.post(`/api/v1/swsec_acl_rule`, params);
  },
  queryRadiusPortConfig: () => {
    return Fetch.get(`/api/v1/radius_port_config`);
  },
  updateRadiusPortConfig: (params) => {
    return Fetch.post(`/api/v1/radius_port_config`, params);
  }
};
